import React from 'react';
import './header.css';

function Header() {
  return (
    <header className="App-header">
        React Todo App
    </header>
  )
}

export default Header